/* eslint-disable no-unused-vars */
import { Delete, Get, Post, PostFormData, Put } from "../Request";

export default {
  state: {
    CourseCategories: [],
    Courses: [],
    coursesIDsAndTitle:[],
    PreviewCourse: null,
    selectedRelatedCourses: [],
    EditCourse: null,
    ActiveCoursesList: [],
    filterCategory: [],
    filterStatus: [],
    filterCourses: [],
    filterType: [],
  },
  getters: {
    GetCourseCategories(state) {
      return state.CourseCategories;
    },
    GetSelectedRelatedCourses(state) {
      return state.selectedRelatedCourses;
    },
    GetCourses(state) {
      return state.Courses;
    },
    GetCoursesIDsAndTitle(state) {
      return state.coursesIDsAndTitle;
    },
    GetEditCourse(state) {
      return state.EditCourse;
    },
    GetPreviewCourse(state) {
      return state.PreviewCourse;
    },
    GetActiveCoursesList(state) {
      return state.ActiveCoursesList;
    },
  },
  actions: {
    async GetCourseCategories({ commit }, payload) {
      return await Get("Course/GetCourseCategories", payload).then((res) => {
        commit("SetCourseCategories", res.data.Data);
        return res.data.Data;
      });
    },
    async GetCourse({ commit }, payload) {
      return await Get(
        `Course/GetCourses/${payload?.page}?pageSize=${
          payload.pageSize
        }&search=${payload.search ?? ""}&filters=${payload.filters}`
      ).then((res) => {
        if (res.data.Data) {
          commit("SetCourses", res.data.Data.List);
        }
        return res.data.Data;
      });
    },
    async GetCoursesIDsAndTitle({ commit }, payload) {
      return await Get(
        `Course/GetCoursesIDsAndTitle/1?pageSize=-1`
      ).then((res) => {
          commit("SetCoursesIDsAndTitle", res.data.Data.List);
        return res.data.Data;
      });
    },
    async GetActiveCoursesList({ commit }, payload) {
      return await Get(`Course/GetActiveCoursesList?page=${payload.page}&pageSize=${payload.pageSize}&search=${payload.search ?? ""}`).then((res) => {
        commit("SetActiveCoursesList", res.data.Data);
        return res.data.Data;
      });
    },
    async CreateCourseCategory({ commit }, payload) {
      return await Post("Course/CreateCourseCategory", payload).then((res) => {
        return res.data;
      });
    },

    async ToggleCourseVisiblity({ commit }, payload) {
      return await Put(`Course/ToogleVisibility?Id=${payload}`).then((res) => {
        return res.data;
      });
    },
    async CreateCourse({ commit }, payload) {
      return await Post("Course/CreateCourse", payload).then((res) => {
        return res.data;
      });
    },
    async UpdateCourse({ commit }, payload) {
      return await Put("Course/UpdateCourse", payload).then((res) => {
        return res.data;
      });
    },
    async UpdateCourseCategory({ commit }, payload) {
      return await Put("Course/UpdateCourseCategory", payload).then((res) => {
        return res.data;
      });
    },
    async DeleteCourseCategory({ commit }, payload) {
      return await Delete(`Course/DeleteCourseCategory?Id=${payload}`).then(
        (res) => {
          return res.data;
        }
      );
    },
    async GetCourseById({ commit }, payload) {
      return await Get(`Course/GetCourseById?Id=${payload}&WebMode=false`).then((res) => {
        commit("SetEditCourse", res.data.Data.Course);
        //  commit("SetRelatedCourses", res.data.Data.data);
        return res.data.Data.Course;
      });
    },

    async PreviewCourse({ commit }, payload) {
      return await Get(`Course/GetCourseById?Id=${payload}`).then((res) => {
        commit("SetPreviewCourse", res.data.Data.Course);

        // commit("SetRelatedCourses", res.data.Data.data);
        return res.data.Data.Course;
      });
    },

    async DuplicateCourseById({ commit }, payload) {
      return await Post(`Course/DuplicateCourse/?Id=${payload}`).then((res) => {
        return res;
      });
    },
    async SortCourseCategory({ commit }, payload) {
      return await Put(
        `Course/SortCourseCategory/${payload.Id}?sortNum=${payload.sortNum}`
      ).then((res) => {
        return res.data;
      });
    },
    async DeleteCourse({ commit }, payload) {
      return await Delete(`Course/DeleteCourse?Id=${payload}`).then((res) => {
        return res.data;
      });
    },
    SetRelatedCourses({ commit }, payload) {
      commit("SetRelatedCourse", payload);
    },
  },
  mutations: {
    SetCourseCategories(state, payload) {
      state.CourseCategories = payload;
    },
    // SetRelatedCourses(state, payload) {
    //   state.selectedRelatedCourses = payload;
    // },
    SetRelatedCourse(state, payload) {
      console.log("payload ",payload)
      if(payload.length == 0){
        state.selectedRelatedCourses = []
        return
      }
      // payload.forEach((item) => {
      //   state.selectedRelatedCourses.push(item);
      // });
      // else{
      //   payload.forEach((item,index) => {
      //     if(index < 3){
      //       state.selectedRelatedCourses.push(item)
      //     }
      //   });
      // }
      //   state.selectedRelatedCourses = payload;
      // }
      // if (payload.length > 0) {
      //   state.selectedRelatedCourses = payload;
      // } else if (
      //   state.selectedRelatedCourses &&
      //   state.selectedRelatedCourses.length < 3
      // ) {
      //   if (state.selectedRelatedCourses.length == 0) {
      //     state.selectedRelatedCourses.push(payload);
      //   } else {
      //     let exist = state.selectedRelatedCourses.find(
      //       (item) => item.Id === payload.Id
      //     );

      //     if (exist) {
      //       state.selectedRelatedCourses = state.selectedRelatedCourses.filter(
      //         (item) => item.Id !== payload.Id
      //       );
      //     } else {
      //       state.selectedRelatedCourses.push(payload);
      //     }
      //   }
      // }
      if (
        state.selectedRelatedCourses.find((x) => x.Id === payload.Id) == null
      ) {
        state.selectedRelatedCourses.push(payload);
      } else {
        state.selectedRelatedCourses = state.selectedRelatedCourses.filter(
          (x) => x.Id !== payload.Id
        );
      }
    },
    SetCourses(state, payload) {
      state.Courses = payload;
    },
    SetCoursesIDsAndTitle(state, payload) {
      let coursesActiveList = payload
        .sort((a, b) => a.Title.localeCompare(b.Title));
      state.coursesIDsAndTitle = coursesActiveList;
    },
    SetEditCourse(state, payload) {
      // payload.Thumbnail = process.env.VUE_APP_IMG_URL + "/" + payload.Thumbnail;
      // payload.Banner = process.env.VUE_APP_IMG_URL + "/" + payload.Banner;
      // payload.Image1 = process.env.VUE_APP_IMG_URL + "/" + payload.Image1;
      // payload.Image2 = process.env.VUE_APP_IMG_URL + "/" + payload.Image2;
      // payload.Image3 = process.env.VUE_APP_IMG_URL + "/" + payload.Image3;
      payload.Thumbnail = payload.Thumbnail ? payload.Thumbnail : payload.Thumbnail;
      payload.Banner = payload.Banner ? payload.Banner : payload.Banner;
      payload.Image1 = payload.Image1 ? payload.Image1 : payload.Image1;
      payload.Image2 = payload.Image2 ? payload.Image2 : payload.Image2;
      payload.Image3 = payload.Image3 ? payload.Image3 : payload.Image3;

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = payload.SubDescription;
      payload.subHeading = tempDiv.textContent || tempDiv.innerText || "";
      payload.filterCategory = payload.CategoryIds
      payload.selectedPermissions = payload.Permissions
      state.EditCourse = payload;
      state.selectedRelatedCourses = [];
      // payload.CourseIds.forEach((id) => {
      //   const course = state.Courses.find((course) => course.Id === id);
      //   if (course) {
      //     state.selectedRelatedCourses.push(course);
      //   }
      // });
      payload.RelatedCourses.forEach((data) => {
        const itemWithStatus = {
          ...data,
          Status: data.IsPublished ? 'Published' : 'Draft',
        };
        state.selectedRelatedCourses.push(itemWithStatus);
      });
    },
    SetActiveCoursesList(state, payload){
      state.ActiveCoursesList = payload
    },
    SetPreviewCourse(state, payload) {
      // payload.Thumbnail = process.env.VUE_APP_IMG_URL + "/" + payload.Thumbnail;
      // payload.Banner = process.env.VUE_APP_IMG_URL + "/" + payload.Banner;
      // payload.Image1 = process.env.VUE_APP_IMG_URL + "/" + payload.Image1;
      // payload.Image2 = process.env.VUE_APP_IMG_URL + "/" + payload.Image2;
      // payload.Image3 = process.env.VUE_APP_IMG_URL + "/" + payload.Image3;
      payload.Thumbnail = payload.Thumbnail ? payload.Thumbnail :payload.Thumbnail;
      payload.Banner = payload.Banner ? payload.Banner : payload.Banner;
      payload.Image1 = payload.Image1 ? payload.Image1 : payload.Image1;
      payload.Image2 = payload.Image2 ? payload.Image2 : payload.Image2;
      payload.Image3 = payload.Image3 ? payload.Image3 : payload.Image3;

      state.PreviewCourse = payload;
      state.selectedRelatedCourses = [];
      payload.CourseIds.forEach((id) => {
        const course = state.Courses.find((course) => course.Id === id);
        if (course) {
          state.selectedRelatedCourses.push(course);
        }
      });
    },
  },
};
